import Link from 'next/link';
import type { ComponentProps, ReactNode } from 'react';

import styles from './link-card.module.scss';

type LinkCardProps = ComponentProps<typeof Link> & {
  thumbnailImage: ReactNode;
  body: ReactNode;
};
export const LinkCard = ({
  thumbnailImage,
  body,
  href,
  rel = 'noopener',
  target = '_blank',
  ...rest
}: LinkCardProps) => (
  <div className={styles.wrapper}>
    <Link href={href} rel={rel} target={target} {...rest}>
      {thumbnailImage}
      {body}
    </Link>
  </div>
);

type ExternalLinkCardProps = ComponentProps<'a'> & {
  thumbnailImage: ReactNode;
  body: ReactNode;
};
export const ExternalLinkCard = ({
  thumbnailImage,
  body,
  href,
  rel = 'noopener',
  target = '_blank',
  ...rest
}: ExternalLinkCardProps) => (
  <div className={styles.wrapper}>
    <a href={href} rel={rel} target={target} {...rest}>
      {thumbnailImage}
      {body}
    </a>
  </div>
);
